import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { CommonFunctions } from "../static/common-functions";
import { CommonValues } from "../static/CommonValues";

export class PhotoBus extends BaseBus {

    constructor(busObj: PhotoBus = null) {
        super(busObj);
        this.createdDate = DateFunctions.getDate(this.createdDate);

    }

    photoId: string;
    photoCategoryId: string;
    sequenceNumber: number;
    imageName: string;
    fileName: string;
    description: string;
    visibleToCustomers: boolean;
    createdDate: Date;
    createdBy: string;
    parentId: any;
}